import { SectionShell } from "@/components/design-system/SectionShell"
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination"

const code = `<Pagination>
  <PaginationContent>
    <PaginationItem>
      <PaginationPrevious href="?page=1" />
    </PaginationItem>
    <PaginationItem>
      <PaginationLink href="?page=1">1</PaginationLink>
    </PaginationItem>
    <PaginationItem>
      <PaginationLink href="?page=2" isActive>2</PaginationLink>
    </PaginationItem>
    <PaginationItem>
      <PaginationEllipsis />
    </PaginationItem>
    <PaginationItem>
      <PaginationNext href="?page=3" />
    </PaginationItem>
  </PaginationContent>
</Pagination>`

export function PaginationSection() {
  return (
    <SectionShell
      id="pagination"
      title="Pagination"
      description="Page navigation adapted from shadcn/ui and styled with the shared button variants."
      whenToUse={
        <ul>
          <li>Long, server-backed collections that should load in bounded pages.</li>
          <li>Results where users need stable URLs and a clear sense of position.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Short collections that fit comfortably on one page.</li>
          <li>Continuous feeds where loading more is the primary interaction.</li>
        </ul>
      }
      preview={
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious href="#pagination" />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#pagination">1</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#pagination" isActive>2</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#pagination">3</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
            <PaginationItem>
              <PaginationNext href="#pagination" />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>Use <code>isActive</code> to identify the current page.</li>
          <li>Keep the current search and filter parameters in every page URL.</li>
          <li>Disable previous and next links at the collection boundaries.</li>
        </ul>
      }
    />
  )
}
